export default __webpack_public_path__ + "static/media/img-as-01.67cb84cf.png";